import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import LeftNav from "./LeftNav";

const AppShell = () => (
  <div className="uag-app-shell uag-shell">
    <Header />
    <div className="uag-layout">
      <LeftNav />
      <main className="uag-content">
        <div className="uag-page-column">
          <Outlet />
          <Footer />
        </div>
      </main>
    </div>
  </div>
);

export default AppShell;
